import axios from "~/plugins/axios";

export default {
  selectionPreview(searchId, dynamicExtendingSearchIds = [], page, perPage, include = [
    "customer",,
  ]) {
    return axios
      .post("/web_api/v1/search_model_interface/selection_preview", {
        searchId,
        dynamicExtendingSearchIds,
        page,
        perPage,
        include,
      })
      .then((response) => response.data);
  },
};
